import { render, staticRenderFns } from "./ServicoListFiltro.vue?vue&type=template&id=a5ee7ffa"
import script from "./ServicoListFiltro.vue?vue&type=script&lang=js"
export * from "./ServicoListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports